module.exports = __webpack_public_path__ + "static/media/edo.0ecb7b83.svg";